import { Component, OnInit } from '@angular/core';
import { PartnerInput } from '../../../models/partner-input.model';
import { PreviewDocumentTypes } from '../../../models/update-customer-ack-document.model';
import { OsmosisService } from '../../services/osmosis.service';
import { CommonSharedModule } from '../../common/shared.module';
import { SharedEngagementTableComponent } from '../../shared/engagement-table/engagement-table.component';

@Component({
  selector: 'app-invoice-doc-review-list',
  templateUrl: './invoice-doc-review-list.component.html',
  styleUrls: ['./invoice-doc-review-list.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, SharedEngagementTableComponent]
})
export class InvoiceDocReviewListComponent implements OnInit {
  engagementList!: PartnerInput[];
  isPoeInvoice = true;
  prevDocumentType!: string;
  loading!: boolean;

  constructor(private osm: OsmosisService) {}

  ngOnInit() {
    this.initializeInvoiceDocReviewList();
    this.prevDocumentType = PreviewDocumentTypes.poeinvoice;
  }

  initializeInvoiceDocReviewList() {
    this.loading = true;
    this.osm.getEngagementsForInvoiceReview().subscribe(serviceOutput => {
      this.engagementList = serviceOutput;
      this.loading = false;
    });
  }
}
